module.exports = __webpack_public_path__ + "img/score_3.559e36d1.png";